import { defineComponent as d, computed as o, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as n, createCommentVNode as h, normalizeStyle as f, createStaticVNode as p } from "vue";
const m = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "f1032c42-aed4-439f-ae68-47c03177d3a4" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#f1032c42-aed4-439f-ae68-47c03177d3a4)" }, u = { key: 0 }, v = /* @__PURE__ */ p('<path fill="#eee" d="M113.7 119.8 276 0h236v31.7L306 289.5 31.6 512H0V276z"></path><path fill="#ffda44" d="M0 0v276L276 0H0z"></path><path fill="#0052b4" d="M512 31.7 31.7 512H512V31.7z"></path><path fill="#333" d="m255 245.7 22.1-12-22-12a78 78 0 0 0-65-65l-12-22-12 22a78 78 0 0 0-65 65l-22 12 22 12a78 78 0 0 0 65 65l12 22.1 12-22a78 78 0 0 0 65-65zm-77 32.6a44.5 44.5 0 1 1 0-89 44.5 44.5 0 0 1 0 89z"></path><path fill="#d80027" d="m178 200.3 9.7 16.7H207l-9.6 16.7 9.6 16.7h-19.3l-9.6 16.7-9.7-16.7h-19.2l9.6-16.7-9.6-16.7h19.2z"></path>', 5), g = { fill: "none" }, x = ["r"], N = /* @__PURE__ */ d({
  __name: "bq-bo",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (z, w) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      _,
      t("g", k, [
        e.flagName ? (s(), i("title", u, n(e.flagName), 1)) : h("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, m));
  }
});
export {
  N as default
};
//# sourceMappingURL=bq-bo-ecb94687.js.map
